module.exports = __webpack_public_path__ + "img/h1.109835c9.jpg";